import { createReducer } from 'app/utils/redux';
import { Record, OrderedSet, Map } from 'immutable';
import {
  CLEAR_SEARCH_LIST,
  SEARCH_LIST_SET_LIST_ITEMS,
  SEARCH_LIST_SET_SUPPLEMENTARY,
  SEARCH_LIST_SET_TOTAL_COUNT,
} from 'app/models/searchLists/constants';
import { ENTITY_DELETED } from 'app/remote/generic/actions';

export const SearchListState = Record({
  list: OrderedSet(),
  supplementary: Map(),
  totalCount: 0,
  atEnd: false,
}, 'ListState');

// Returns a new SearchListState if there is none for the corresponding searchId.
const updateSearchList = (state, searchId, callback) =>
  state.update(searchId, (listState = new SearchListState()) => callback(listState));

const searchListsReducer = createReducer(Map(), {
  [CLEAR_SEARCH_LIST]: (state, { payload: { searchId } }) =>
    state.delete(searchId),

  [SEARCH_LIST_SET_LIST_ITEMS]: (state, { payload: { searchId, itemIds } }) =>
    updateSearchList(state, searchId, listState => (
      itemIds.length === 0
        ? listState.set('atEnd', true)
        : listState.update('list', list => list.concat(itemIds))
    )),

  [SEARCH_LIST_SET_SUPPLEMENTARY]: (state, { payload: { searchId, supplementary = {} } }) =>
    updateSearchList(state, searchId, s => s.mergeIn(['supplementary'], supplementary)),

  [SEARCH_LIST_SET_TOTAL_COUNT]: (state, { payload: { searchId, totalCount } }) =>
    updateSearchList(state, searchId, s => s.set('totalCount', totalCount)),

  [ENTITY_DELETED]: (state, { payload: { id: deletedId } }) =>
    state.map(listState => (
      listState.update('list', list => list.filter(id => id !== deletedId))
    )),
});

export default searchListsReducer;
